<template>
  <el-form
    el-form
    :model="ruleForm"
    :rules="rules"
    ref="ruleForm"
    label-width="100px"
    class="add"
  >
    <div class="top">
      <div class="left">
        <div class="title">成套设备租赁</div>
        <div class="content">
          <div class="image">
            <el-upload
              class="avatar-uploader"
              :multiple="false"
              :action="$uploadUrl"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
            >
              <div class="image-area" v-if="ruleForm.pictureUrl">
                <img :src="$imgUrl + ruleForm.pictureUrl" class="avatar" />
                <span>更换</span>
              </div>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
          <div class="name">
            <div class="key">产品标题</div>
            <div class="value">
              <el-input
                type="textarea"
                :rows="5"
                placeholder="请输入产品标题"
                v-model="ruleForm.name"
              ></el-input>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="title">设备信息</div>
        <div class="form">
          <el-form-item label="提供人姓名" prop="userName">
            <el-input
              v-model="ruleForm.userName"
              placeholder="请输入提供人姓名"
              style="width: 220px;"
            ></el-input>
          </el-form-item>
          <el-form-item label="设备类型" prop="type">
            <el-select v-model="ruleForm.type" placeholder="请选择设备类型">
              <el-option
                v-for="(item, index) in typeList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="设备容量" prop="volumeId">
            <el-select v-model="ruleForm.volumeId" placeholder="请选择设备容量">
              <el-option
                v-for="(item, index) in volumeList"
                :key="index"
                :label="item.volume"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="设备电压" prop="voltageId">
            <el-select
              v-model="ruleForm.voltageId"
              placeholder="请选择设备电压"
            >
              <el-option
                v-for="(item, index) in voltageList"
                :key="index"
                :label="item.voltage"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="address" label="设备地址">
            <el-cascader
              :props="props"
              v-model="ruleForm.address"
              :options="regionList"
              placeholder="请选择设备地址"
              @change="addressChange"
            ></el-cascader>
          </el-form-item>
        </div>
      </div>
    </div>
    <div class="price">
      <div class="title">
        阶梯价格设置
        <span
          >价格为设备租赁，客户下单后需要厂商根据方案核定价格。（租赁周期为3-6-9-12月，可填写价格，时间无法修改。）</span
        >
      </div>
      <div class="list">
        <div class="item">
          <div class="key">
            *租赁期限：
            <span>3月</span>
          </div>
          <div class="value">
            <el-form-item prop="price_1">
              <el-input
                type="number"
                placeholder="请输入"
                v-model="ruleForm.price_1"
              >
                <template slot="append">
                  /元
                </template>
              </el-input>
            </el-form-item>
          </div>
        </div>
        <div class="item">
          <div class="key">
            *租赁期限：
            <span>6月</span>
          </div>
          <div class="value">
            <el-form-item prop="price_2">
              <el-input
                type="number"
                placeholder="请输入"
                v-model="ruleForm.price_2"
              >
                <template slot="append">
                  /元
                </template>
              </el-input>
            </el-form-item>
          </div>
        </div>
        <div class="item">
          <div class="key">
            *租赁期限：
            <span>9月</span>
          </div>
          <div class="value">
            <el-form-item prop="price_3">
              <el-input
                type="number"
                placeholder="请输入"
                v-model="ruleForm.price_3"
              >
                <template slot="append">
                  /元
                </template>
              </el-input>
            </el-form-item>
          </div>
        </div>
        <div class="item">
          <div class="key">
            *租赁期限：
            <span>12月</span>
          </div>
          <div class="value">
            <el-form-item prop="price_4">
              <el-input
                type="number"
                placeholder="请输入"
                v-model="ruleForm.price_4"
              >
                <template slot="append">
                  /元
                </template>
              </el-input>
            </el-form-item>
          </div>
        </div>
      </div>
    </div>
    <div class="description">
      <div class="title">配件说明</div>
      <div class="hint">*填写成套服务方案单价。</div>
      <div class="list">
        <!-- <div class="item">
					<div class="key">500kva箱变</div>
					<div class="value">
						<el-input type="number" placeholder="请输入" v-model="ruleForm.money_1">
							<template slot="append">
								元/套
							</template>
						</el-input>
					</div>
				</div> -->
        <div class="item">
          <div class="key">架空线路</div>
          <div class="value">
            <el-input
              type="number"
              placeholder="请输入"
              v-model="ruleForm.money_2"
            >
              <template slot="append">
                元/档
              </template>
            </el-input>
          </div>
        </div>
        <div class="item">
          <div class="key">电缆线路</div>
          <div class="value">
            <el-input
              type="number"
              placeholder="请输入"
              v-model="ruleForm.money_3"
            >
              <template slot="append">
                元/米
              </template>
            </el-input>
          </div>
        </div>
        <div class="item">
          <div class="key">单杆</div>
          <div class="value">
            <el-input
              type="number"
              placeholder="请输入"
              v-model="ruleForm.money_4"
            >
              <template slot="append">
                元/个
              </template>
            </el-input>
          </div>
        </div>
      </div>
    </div>
    <div class="button">
      <el-button type="primary" @click="submitForm('ruleForm')">{{
        id == "" ? "立即创建" : "保存修改"
      }}</el-button>
      <el-button @click="resetForm('ruleForm')">重置</el-button>
    </div>
  </el-form>
</template>

<script>
import {
  addEquipment,
  equipmentDetail,
  ProvinceList,
  equipmentType,
  equipmentVolumeApi,
  equipmentVoltageApi,
} from "../../http/factory/add-eme.js";
export default {
  name: "add",
  data() {
    return {
      ruleForm: {
        pictureUrl: "",
        name: "",
        userName: "",
        volumeId: "",
        voltageId: 2,
        address: "",
        type: "",
        price_1: "",
        price_2: "",
        price_3: "",
        price_4: "",
        money_1: "",
        money_2: "",
        money_3: "",
        money_4: "",
      },
      rules: {
        userName: [
          {
            required: true,
            message: "请输入提供人姓名",
            trigger: "blur",
          },
        ],
        volumeId: [
          {
            required: true,
            message: "请选择设备容量",
            trigger: "change",
          },
        ],
        voltageId: [
          {
            required: true,
            message: "请选择输出电压",
            trigger: "change",
          },
        ],
        address: [
          {
            required: true,
            message: "请选择设备地址",
            trigger: "change",
          },
        ],
        type: [
          {
            required: true,
            message: "请选择设备类型",
            trigger: "change",
          },
        ],
        price_1: [
          {
            required: true,
            message: "请输入价格",
            trigger: "change",
          },
        ],
        price_2: [
          {
            required: true,
            message: "请输入价格",
            trigger: "change",
          },
        ],
        price_3: [
          {
            required: true,
            message: "请输入价格",
            trigger: "change",
          },
        ],
        price_4: [
          {
            required: true,
            message: "请输入价格",
            trigger: "change",
          },
        ],
      },
      props: {
        label: "label",
        value: "id",
      },
      typeList: [],
      regionList: [],
      volumeList: [],
      voltageList: [],
      id: "",
    };
  },
  created() {
    let id = this.$route.query.id;
    if (id) {
      this.id = id;
      this.fetchData();
    }
    this.init();
  },
  methods: {
    // 获取设备信息
    fetchData() {
      equipmentDetail({
        id: this.id,
      }).then((res) => {
        this.ruleForm = {
          pictureUrl: res.pictureUrl,
          name: res.title,
          userName: res.userName,
          volumeId: res.volumeId,
          voltageId: res.voltageId,
          address: [
            parseInt(res.province),
            parseInt(res.city),
            parseInt(res.county),
          ],
          type: res.typeId,
          price_1: res.priceGears.price,
          price_2: res.priceGears.price1,
          price_3: res.priceGears.price2,
          price_4: res.priceGears.price3,
          money_1: res.priceGears.xbxl,
          money_2: res.priceGears.jkxl,
          money_3: res.priceGears.dlxl,
          money_4: res.priceGears.dgxl,
        };
      });
    },
    // 初始化表单项
    init() {
      // 设备类型
      equipmentType({
        serviceType: 0,
      }).then((res) => {
        this.typeList = res;
      });
      // 省市区
      ProvinceList().then((data) => {
        this.regionList = data;
      });
      // 设备容量
      equipmentVolumeApi({
        serviceType: 0,
      }).then((res) => {
        this.volumeList = res;
      });
      // 设备电压
      equipmentVoltageApi({
        serviceType: 0,
      }).then((res) => {
        this.voltageList = res;
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveInfo();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      if (this.id == "") {
        this.$refs[formName].resetFields();
      } else {
        this.fetchData();
      }
    },
    handleAvatarSuccess(file) {
      this.ruleForm.pictureUrl = file.fileName;
    },
    //选中地址
    addressChange(value) {
      this.ruleForm.province = value[0];
      this.ruleForm.city = value[1];
      this.ruleForm.county = value[2];
    },
    // 保存设备信息
    saveInfo() {
      let data = {
        serviceType: 0,
        pictureUrl: this.ruleForm.pictureUrl,
        title: this.ruleForm.name,
        userName: this.ruleForm.userName,
        voltageId: this.ruleForm.voltageId,
        volumeId: this.ruleForm.volumeId,
        typeId: this.ruleForm.type,
        province: this.ruleForm.address[0],
        city: this.ruleForm.address[1],
        county: this.ruleForm.address[2],
        priceGears: {
          price: this.ruleForm.price_1,
          price1: this.ruleForm.price_2,
          price2: this.ruleForm.price_3,
          price3: this.ruleForm.price_4,
          xbxl: this.ruleForm.money_1,
          jkxl: this.ruleForm.money_2,
          dlxl: this.ruleForm.money_3,
          dgxl: this.ruleForm.money_4,
        },
      };
      if (this.id != "") {
        data["id"] = this.id;
      }
      addEquipment(data).then((res) => {
        this.$message({
          message: this.id == "" ? "添加设备成功" : "编辑设备成功",
          type: "success",
          duration: 2000,
          onClose: () => {
            this.$router.back();
          },
        });
      });
    },
  },
};
</script>

<style lang="less" scoped="scoped">
.add {
  width: 100%;

  .title {
    width: 100%;
    height: 50px;
    border-bottom: 1px solid @vue-border-color;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    padding: 0px @vue-spacing-row-base;

    span {
      margin-left: @vue-spacing-row-sm;
      font-size: @vue-font-size-sm - 2;
      color: @vue-text-color-red;
    }
  }

  .top {
    width: 100%;
    display: flex;
    justify-content: space-between;

    .left,
    .right {
      width: 49%;
      background: @vue-bg-color;
    }

    .left {
      .content {
        width: 100%;
        padding: @vue-spacing-col-base @vue-spacing-row-base;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;

        .image {
          width: 220px;

          .avatar-uploader .el-upload {
            border-radius: 6px;
            cursor: pointer;
            position: relative;
            overflow: hidden;
          }

          .avatar-uploader-icon {
            font-size: 28px;
            color: #8c939d;
            width: 178px;
            height: 178px;
            line-height: 178px;
            text-align: center;
            border: 1px dashed #d9d9d9;
          }

          .avatar-uploader-icon:hover {
            border-color: #409eff;
          }

          .image-area {
            width: 178px;
            height: 178px;
            position: relative;

            img {
              width: 100%;
              height: 100%;
              display: block;
            }

            span {
              width: 100%;
              height: 30px;
              position: absolute;
              left: 0px;
              bottom: 0px;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: @vue-font-size-sm - 2;
              color: @vue-text-color-inverse;
              background: @vue-bg-color-mask;
            }
          }
        }

        .name {
          width: calc(100% - 300px);
          height: 100%;
          display: flex;
          justify-content: space-between;

          .key {
            width: 80px;
            height: 40px;
            display: flex;
            align-items: center;
            font-size: @vue-font-size-sm - 2;
            font-weight: bold;
          }

          .value {
            width: calc(100% - 80px);
            height: 100px;
          }
        }
      }
    }

    .right {
      .form {
        width: 100%;
        padding: @vue-spacing-col-base @vue-spacing-row-base;
        box-sizing: border-box;
        .el-form-item {
          display: flex;

          /deep/ .el-form-item__content {
            margin-left: 30px !important;
          }
        }
      }
    }
  }

  .price,
  .description {
    width: 100%;
    background: @vue-bg-color;
    margin-top: @vue-spacing-col-lg;

    .hint {
      width: 100%;
      height: 40px;
      display: flex;
      align-items: center;
      color: @vue-text-color-red;
      font-size: @vue-font-size-sm - 2;
      padding: 0px @vue-spacing-row-base;
      box-sizing: border-box;
    }

    .list {
      width: 100%;
      padding: @vue-spacing-col-base @vue-spacing-row-base;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;

      .item {
        width: 25%;
      }
    }
  }

  .price {
    .list {
      .item {
        .key,
        .value {
          width: 100%;
        }

        .key {
          height: 30px;
          font-size: @vue-font-size-sm - 2;
          color: orange;
        }

        .value {
          padding-right: @vue-spacing-row-base;
          box-sizing: border-box;
        }
      }
    }
  }

  .description {
    .list {
      .item {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .key {
          width: 100px;
          font-size: @vue-font-size-sm - 2;
          color: @vue-text-color-grey;
        }

        .value {
          width: calc(100% - 100px);
          padding-right: @vue-spacing-row-base;
          box-sizing: border-box;
        }
      }
    }
  }

  .button {
    width: 100%;
    margin-top: @vue-spacing-col-lg;
    display: flex;
    justify-content: flex-end;
    padding-bottom: @vue-spacing-col-lg;
  }
}
</style>
